<span
  class="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-lPrimary font-semibold text-white"
  [ngClass]="sizeClass"
>
  @if (showImage) {
    <img
      class="h-full w-full object-cover"
      [src]="imageUrl"
      [alt]="name"
      (error)="onImageError()"
    />
  } @else {
    {{ initials }}
  }
</span>
